import React, { useContext } from 'react';
import {
  RaasAssessmentDto,
  RecommendationGenerationStatusDto
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { AppContext } from '../app/AppProvider.component';
import { isInstructorUser } from '../../utilities/remediation.utilities';

export const StatusMessage = (props: {
  raasAssessment: Partial<RaasAssessmentDto>;
}): JSX.Element => {

  const {
    appState,
  } = useContext(AppContext);

  const {
    raasAssessment,
  } = props;

  const {
    userRole
  } = appState;

  if (!raasAssessment) {
    return (
      <div className="u-els-font-size-h3">
        {!isInstructorUser(userRole) ? 'Your' : 'The student\'s'} plan could not be found. Please check back later.
      </div>
    );
  }

  if (raasAssessment.recGenerationStatus === RecommendationGenerationStatusDto.COMPLETED) {
    return null;
  }

  if (raasAssessment.recGenerationStatus === RecommendationGenerationStatusDto.ERROR) {
    return (
      <div className="u-els-font-size-h3">
        There was an error creating {!isInstructorUser(userRole) ? 'your' : 'the student\'s'} plan. Please check back later or contact support.
      </div>
    );
  }

  return (
    <div className="u-els-font-size-h3">
      {!isInstructorUser(userRole) ? 'Your' : 'The student\'s'} plan is being created. Please check back later.
    </div>
  )
};
